import React from 'react';
import i18next from 'i18next';

function Reason() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <>
                    <h3 id='title'>أسباب اضطراب طيف التوحد</h3>
                    <p>
                        أسباب اضطراب طيف التوحد غير معروفة حتى الآن، ولكن
                        الاضطراب يتطور نتيجة تفاعل مجموعة من العوامل الجينية، و
                        البيئية:
                    </p>
                    <h4 id='title'>العوامل الجينية</h4>
                    <p>
                        بسبب الطفرات في الجينات، أما أن تكون الطفرات موروثة من
                        الوالدين، أو أن تكون الطفرات ذاتية موجودة في الطفل وليست
                        موجودة في الوالدين.
                    </p>
                    <h4 id='title'>العوامل البيئية</h4>
                    <ul id='last'>
                        <li>التقدم في عمر الوالدين (أو أحدهما).</li>
                        <li>
                            المضاعفات عند الحمل والولادة على سبيل المثال: الخداج
                            وهي ولادة الطفل قبل ٢٦ أسبوعًا من اليوم المحدد
                            للولادة، انخفاض وزن الطفل عند الولادة، الحمل المتعدد
                            [التوأم، ثلاث توأم، إلخ].
                        </li>
                        <li>الحمل المتتابع لمدة تكون أقل من سنة واحدة.</li>
                    </ul>
                    <h3 id='title'>
                        العلاقة بين التطعيمات (اللقاحات) (باعتباره عاملاً
                        بيئيًا) وخطر الاصابة باضطراب طيف التوحد
                    </h3>
                    <ul>
                        <li>
                            لا تدعم الأبحاث العلمية ارتباط التطعيمات (اللقاحات)
                            (باعتباره عاملاً بيئيًا )بزيادة خطر الاصابة باضطراب
                            طيف التوحد.
                        </li>
                        <li>
                            التطعيمات الروتينية التي تعطى للأم أثناء الحمل مثل:
                            التطعيمات ضد الانفلونزا ومرض السعال الديكي، لا تزيد
                            خطر الإصابة باضطراب طيف التوحد.
                        </li>
                        <li>
                            أن الأبحاث التي زعمت ظهور علاقة سببية بين التطعيمات
                            و الإصابة باضطراب طيف التوحد، كانت دراسات غير صحيحة
                            وقد تم التراجع عنها، ولم يظهر أي دليل موثوق وقوي
                            لتأييد علاقة تطعيمات الأطفال والتوحد.
                        </li>
                    </ul>
                </>
            ) : (
                <>
                    <h3 id='causes-of-autism'>Causes of Autism</h3>
                    <p>
                        There’s no one cause of autism. Research suggests that
                        autism develops from a combination of genetic, or
                        environmental, influences.
                    </p>
                    <h4 id='autism-s-genetic-risk-factors-'>
                        Autism’s genetic risk factors:
                    </h4>
                    <p>inherited mutations and spontaneous mutations </p>
                    <h4 id='autism-s-environmental-risk-factors'>
                        Autism’s environmental risk factors
                    </h4>
                    <ul>
                        <li>Advanced parent age (either parent)</li>
                        <li>
                            Pregnancy and birth complications (e.g. extreme
                            prematurity [before 26 weeks], low birth weight,
                            multiple pregnancies [twin, triplet, etc.],high
                            blood pressure){' '}
                        </li>
                        <li>Pregnancies spaced less than one year apart</li>
                    </ul>
                    <h3 id='vaccines-and-autism'>Vaccines and Autism</h3>
                    <ul>
                        <li>
                            The results of this research is clear: Vaccines do
                            not cause autism
                        </li>
                        <li>
                            Despite the links between maternal immune factors
                            and autism, routine vaccinations given during
                            pregnancy, such as those against influenza and
                            whooping cough, do not appear to boost autism risk.
                        </li>
                        <li>
                            Childhood vaccines are similarly in the clear. The
                            research that purported to show a causal link was
                            fraudulent and has been retracted, and no reliable
                            evidence has ever emerged to support it.
                        </li>
                    </ul>
                </>
            )}
        </>
    );
}

export default Reason;
